import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class WebsiteService extends ApiService {
  namespace = "website";
  template = "WebsiteTemplate";
  favicon = "Globe";
  DOMAIN = 25;
  icon = "World";
  name = "Website";
  action = "action";

  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.name }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
  ];

  constructor() {
    super("websites");
  }
}
